import { School } from '../school';
import { ClassType } from '../class-type';
import { Student } from '../student';
import { Reservation } from '../reservation';
import { Card } from '../card';
import { Location } from '../location';

export const enum EventStatus {
    'DRAFT',
    'PUBLISHED',
    'EXECUTED',
    'CANCELLED'

}

export const enum EventCategory {
    'WORKSHOP',
    'TEACHER_TRAINING',
    'RETREAT',
    'MASTERCLASS',
    'INTRO_CLASS',
    'CONCERT',
    'OPEN_DOOR',
    'OTHER'
}

export class Event {

    constructor(
        public school?: School,
        public id?: number,
        public title?: string,
        public imageUrl?: string,
        public begining?: any,
        public ending?: any,
        public reminderPolicy?: number,
        public status?: EventStatus,
        public category ?: EventCategory,
        public description?: string,
        public minParticipants?: number,
        public maxParticipants?: number,
        public facilitator?: Student,
        public freeTextFacilitator?: string,
        public location?: Location,
        public freeTextLocation?: string,
        public free?: boolean,
        public backOfficeUnitPriceId?: string,
        public acceptOnlinePayments?: boolean,
        public standardUnitPrice?: number,
        public videoConference?: boolean,
        public videoConferenceUrl?: string,
        public facebookUrl?: string,
        public availablePlaces?: number,
        public bookings?: number,
        public highlighted?: boolean,
        public bookAndPayLaterEnabled?: boolean,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event/event.model.ts